export const STORAGE = {
  NOTIFICATIONS: "notifications",
  SMARTLINK_TOKEN: "smartlink-bo-token",
  GRAPH_TOKEN: "accessToken",
};
